import { type FC } from "react";

import { faSparkles } from "@fortawesome/pro-duotone-svg-icons/faSparkles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Popover, PopoverButton } from "@headlessui/react";

import { Button } from "@styled/button";
import { DropdownPanel } from "@styled/dropdown_panel";
import { PillChevron, PillLabel } from "@styled/pill_group";
import { QuestionRow } from "@styled/question_row";

// The answering assistant's questions, one list. One click sends; greyed out
// while the chat you're in is answering.
export const SuggestedQuestionsMenu: FC<{
  questions: string[];
  disabled: boolean;
  onAsk(question: string): void;
}> = ({ questions, disabled, onAsk }) => (
  <Popover>
    <PopoverButton
      as={Button}
      type="button"
      color="white"
      size="sm"
      disabled={disabled || questions.length === 0}
    >
      <FontAwesomeIcon icon={faSparkles} />
      <PillLabel>Suggested questions</PillLabel>
      <PillChevron />
    </PopoverButton>
    <DropdownPanel>
      {({ close }) => (
        <>
          {questions.map((question) => (
            <QuestionRow
              key={question}
              onClick={() => {
                close();
                onAsk(question);
              }}
            >
              {question}
            </QuestionRow>
          ))}
        </>
      )}
    </DropdownPanel>
  </Popover>
);
